import moment from 'moment'

// Display time in local time. Input date/time in UTC format
const displayDate = (date) => date ? moment(date).format('YYYY/MM/DD') : null
const displayDateWithTime = (date) => date ? moment(date).format('YYYY/MM/DD HH:mm') : null

export {
  displayDate,
  displayDateWithTime
}